import type { InjectionToken } from "tsyringe";
import { injectable } from "tsyringe";
import type {
  DataStorage,
  DataStorageFactory,
  StorageProviderName,
  StorageProviderOptions,
} from "../../domain/storage";
import { InMemoryDataStorage } from "./InMemoryDataStorage";

export interface IDataStorageFactory extends DataStorageFactory {}

export const DATA_STORAGE_FACTORY_TOKEN = Symbol(
  "IDataStorageFactory",
) as InjectionToken<IDataStorageFactory>;

@injectable()
export class DefaultDataStorageFactory implements IDataStorageFactory {
  async create(
    provider: StorageProviderName,
    _options?: StorageProviderOptions,
  ): Promise<DataStorage> {
    if (provider === "local") {
      return new InMemoryDataStorage();
    }

    throw new Error(
      `Storage provider "${provider}" is not implemented yet. Use "local" for now.`,
    );
  }
}
